/**
 * The base view for this application. Initialises all objects and global events
 * @class
 */

UserDocs.View.AppView = Backbone.View.extend(
/** @lends UserDocs.View.AppView# */
{
	/** Element used by Backbone.js to attach events and represent this view */
    el: $("body"),

	/** The events we're listening to*/
    events: {
		"click a.e_document_launch_evm": 		"evmOpen"
	},

	/** 
	 * Initialisation function called when this object is created. 
	 * Create all the 'global' objects to this app and trigger some rendering 
	 */
    initialize: function() {
    
    },
    
    evmOpen: function(e) {
    	if (ele.config.usersession.isloggedin) {
	    	let evmView = new UserDocs.View.Modal.EVMModal();
			evmView.loadTemplate($(e.target).attr('href'));
			return false;
    	}
    }
});
